import type { IWalleeTransactionToAuthorize, IWorldlineTransactionToAuthorize } from "@/data/model/Customer";


export function setBearerToken(token: string | null) {
    const serializedMessage = JSON.stringify({
        token: token,
    });

    const android = (window as any)?.Android;
    if (android != null && typeof android.setBearerToken === "function") {
        android.setBearerToken(serializedMessage);
    }
}

export function sendWalleeTransactionToAuthorize(walleeTransactionToAuthorize: IWalleeTransactionToAuthorize) {
    const serializedMessage = JSON.stringify({
        transaction: walleeTransactionToAuthorize,
    });

    const android = (window as any)?.Android;
    if (android != null) {
        if (typeof android.sendWalleeTransactionToAuthorizeV2 === "function") {
            android.sendWalleeTransactionToAuthorizeV2(
                walleeTransactionToAuthorize.externalPaymentId,
                serializedMessage
            );
        } else if (typeof android.sendWalleeTransactionToAuthorize === "function") {
            android.sendWalleeTransactionToAuthorize(serializedMessage);
        }
    }
}

export function sendWorldlineTransactionToAuthorize(worldlineTransactionToAuthorize: IWorldlineTransactionToAuthorize, operatorAppPaymentUrl: string | undefined) {
    const serializedMessage = JSON.stringify({
        operatorAppPaymentUrl: operatorAppPaymentUrl,
        transaction: worldlineTransactionToAuthorize,
    });

    const android = (window as any)?.Android;
    if (android != null && typeof android.sendWorldlineTransactionToAuthorize === "function") {
        android.sendWorldlineTransactionToAuthorize(serializedMessage);
    }
}

export function getNativeAppVersion(): string | undefined {
    const android = (window as any)?.Android;

    if (android != null && typeof android.getNativeAppVersion === "function") {
        return android.getNativeAppVersion();
    }

    return undefined;
}

export function isWalleeSdkAvailable(): boolean | undefined {
    const android = (window as any)?.Android;

    if (android != null && typeof android.isWalleeSdkAvailable === "function") {
        return android.isWalleeSdkAvailable();
    }

    return undefined;
}

export function isRunnningInNativeMode(): boolean {
    const version = getNativeAppVersion();
    return version != null && version.length > 0;
}

export function isCheckWorldlineLastFailedTransactionAvailable(): boolean {
    const android = (window as any)?.Android;
    return typeof android?.checkWorldlineLastFailedTransaction === "function";
}
export function checkWorldlineLastFailedTransaction () {
    if (isCheckWorldlineLastFailedTransactionAvailable()) {
        const android = (window as any)?.Android;
        android.checkWorldlineLastFailedTransaction();
    }
};
